import { useTranslation } from "@bounce/i18n"

import { config } from "../../../config/config"
import type { NavbarProps } from "@/components/Generic/Navbar/Navbar"
import { useNavbar as useLuggageStorageNavbar } from "@/components/LuggageStorage/Navbar/useNavbar"

export type UseNavbarOptions = Pick<NavbarProps, "languages">

export const useNavbar = ({ languages }: UseNavbarOptions): NavbarProps => {
  const { t } = useTranslation("marketing-partner")
  const luggageStorageNavbarProps = useLuggageStorageNavbar({ languages })

  const navbarProps: NavbarProps = {
    ...luggageStorageNavbarProps,
    links: {
      ...luggageStorageNavbarProps.links,
      auth: { children: t("cmp.partner.navbar.login", "Log in"), href: `${config.apps.partner}/login` },
      account: {
        children: t("cmp.partner.navbar.bookings", "My bookings"),
        href: `${config.apps.partner}/bookings`,
      },
    },
  }

  return navbarProps
}
